import { getPersonalizationAccess } from 'personalization-lib/utils/auth';
import { useGetPersonalizationStrategyQuery } from 'page-editor-ui/__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeRpc.hooks';
export const usePersonalizationStrategyType = strategyId => {
  var _data$personalization;
  const personalizationAccess = getPersonalizationAccess();
  const {
    data,
    loading,
    error
  } = useGetPersonalizationStrategyQuery({
    variables: {
      id: strategyId
    },
    skip: !strategyId || !personalizationAccess.view
  });
  return {
    strategyType: data === null || data === void 0 || (_data$personalization = data.personalizationStrategy) === null || _data$personalization === void 0 ? void 0 : _data$personalization.strategyType,
    loading,
    error
  };
};